// @flow
import I18n from 'node-polyglot'

type Options = {
  locale?: string
}

export default function translateFunc(translations: Object, options: Options = {}) {
  let i18nOptions: Object = { phrases: translations }

  if (options.locale) i18nOptions.locale = options.locale

  let i18n = new I18n(i18nOptions)

  return (...args: any) => i18n.t(...args)
}
